import {
  Divider,
  Grid,
  Paper,
  Typography
} from "@mui/material";

const Section = ({ children, title, actionButton = undefined }) => {
  return (
    <Paper sx={{ borderRadius: 2.25, mb: 2, py: 2.25 }} >
      <Grid container spacing={2} sx={{ px: 2.25, mb: 2, borderBottomWidth: "1px"}}>
        <Grid item xs={6}>
          <Typography variant="h5" sx={{ alignSelf: "left", fullWidth: true }}>
            {title}
          </Typography>
        </Grid>
        {actionButton && (
          <Grid item xs={6} sx={{ display: "flex", flexDirection: "column" }}>
            {actionButton}
          </Grid>
        )}
      </Grid>
      <Divider />
      <Grid container spacing={2} sx={{ px: 2.25, pt: 3 }}>
        {children}
      </Grid>
    </Paper>
  )
}

export default Section;
